define('modules/carousel/carousel',[
	'app',
	'jquery',
	'backbone',
	'underscore',
	'owl',
],
function(app, $, Backbone, _, OwlCarousel) {

	return Backbone.View.extend({
		el: '.js-ptera-carousel',
		$el: $(this.el),
		isActive: false,
		currentIndex: 0,
		maxCount: 0,
		listener: false,

		initialize: function(){
			if (this.$el.length > 0 ){ 
				_.bindAll(this, 'toggleDisplay', 'triggerNext', 'triggerPrevious', 'updateIndex', 'attachListeners', 'removeListeners');

				this.toggleDisplay();
				if (!this.listener) {
					this.attachListeners();
					this.listener = true;				
				}
			}
		},

		toggleDisplay: function() {
			if (this.$el.length > 0 ){ 
				if (!this.isActive) {
					this.$inner = this.$el.find('.carousel__items');
					this.$inner.owlCarousel({
						singleItem: false,
						items: 3,
						itemsScaleUp: true,
						singleItem: false,
						itemsDesktop: [1024, 3],
						itemsDesktopSmall: [1023, 2],
						itemsTablet: [768, 2],
						itemsTabletSmall: [767, 1],
						itemsMobi: [768, 1],
						pagination: false,
						navigation: false,
						scrollPerPage: 1,
						afterMove: this.updateIndex,
						mouseDrag : false,
						touchDrag: false,
					});
					this.maxCount = this.$el.find('.carousel__item').length - 1;
					this.isActive = true;
					this.owl = $(this.$inner).data('owlCarousel');
					delete this.$inner;
				}

				if (this.isActive) {
					if (app.IEVersion !== 8 ) {
						if (!app.isMobile(768)) {
							this.owl.reinit({
								singleItem: false,
							});
						}
						if ($('html').hasClass('no-touch')) {
							this.owl.reinit({
								touchDrag : false,
							});						
						} else if ($('html').hasClass('touch')) {
							this.owl.reinit({
								touchDrag : true,
							});						
						}
					}
				}
			}
		},

		attachListeners: function() {
			var toggleDisplay = this.toggleDisplay;
			this.$el = $(this.el);
			if (app.IEVersion !== 8 ) {
				$(this.$el).on("resize", function(){
					toggleDisplay();
				});
			}

			if (app.IEVersion == 8 ) {
				$(window).ready( function() {
					toggleDisplay();
				});
			}

			var triggerNext = this.triggerNext;
			var triggerPrevious = this.triggerPrevious;

			// Backbone events just died?
			// events: {
				$('.js-ptera-carousel-next').on('click', function(){
					triggerNext();
				});
				$('.js-ptera-carousel-previous').on('click', function(){
					triggerPrevious();
				});
			// },
		},

		removeListeners: function(removeElementListener) {
			$(this.$el).off('resize');
			$(window).off('load');
			delete this.$el;
		},

		destroyCarousel: function() {
			if (this.owl){
				this.owl.destroy();				
			}
		},

		updateIndex: function() {
			var currentItems = this.owl.visibleItems;
			this.currentIndex = currentItems[0] - 1 < 0 ? 0 : currentItems[0] - 1;
		},

		triggerNext: function() {
			// console.log('next fired');
			if(!app.isMobile(768)) {
				var newIndex = this.currentIndex + 1 >= this.maxCount - 1 ? 0 : this.currentIndex + 1;
				this.owl.goTo(newIndex);
				this.currentIndex = newIndex;
			}
		},

		triggerPrevious: function() {
			// console.log('previous fired');
			if(!app.isMobile(768)) {
				var newIndex = this.currentIndex - 1 < 0 ? this.maxCount -2 : this.currentIndex - 1;
				this.owl.goTo(newIndex);
				this.currentIndex = newIndex;
			}
		}

	});

});

